import { Injectable } from "@angular/core";
import { EsBaseTemplateService } from "../shared/es-base-template.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { LoginResponse, UserTypesModel } from "../../models/user-profile/user-types.model";
import { environment } from "src/environments/environment";

@Injectable()

export class UserTypesService extends EsBaseTemplateService{
    protected override BASE_API: string = environment.loginDomainURL;
    protected APIManagerKeyHeader: string = environment.loginAPIManagerKeyHeader;
    protected APIManagerKey: string = environment.loginAPIManagerKey;
    basePath: string = "account";

    constructor(private httpClient: HttpClient) {
        super();
    }

    public GetUsers(code:string): Observable<UserTypesModel> {
        let url = this.buildUrl(`Users?code=${code}`);
        const headers = new HttpHeaders({ [this.APIManagerKeyHeader]: this.APIManagerKey });
        return this.httpClient
            .get<UserTypesModel>(url, {headers: headers, withCredentials:true})
            .pipe(catchError(this.handleError));
    }

    public GetUsersBySessionKey(sessionKey:string): Observable<UserTypesModel> {
        let url = this.buildUrl(`UsersBySessionKey?sessionKey=${sessionKey}`);
        const headers = new HttpHeaders({ [this.APIManagerKeyHeader]: this.APIManagerKey });
        return this.httpClient
            .get<UserTypesModel>(url, {headers: headers, withCredentials:true})
            .pipe(catchError(this.handleError));
    }

    public Login(token:any): Observable<LoginResponse> {
        let url = this.buildUrl(`Login`);
        const headers = new HttpHeaders({ [this.APIManagerKeyHeader]: this.APIManagerKey });
        return this.httpClient
            .post<LoginResponse>(url,token, {headers:headers, withCredentials:true})
            .pipe(catchError(this.handleError));
    }

    public override buildUrl(endingUri: string): string {
        return `${this.BASE_API}${this.basePath}/${endingUri}`;
      } 

}